
          import $$Component from "/home/runner/work/wp-tm-tos168/wp-tm-tos168/typescript/popup/Entertainment.vue?vue&type=script"
          
          import { render } from "/home/runner/work/wp-tm-tos168/wp-tm-tos168/typescript/popup/Entertainment.vue?vue&type=template"
          export * from "/home/runner/work/wp-tm-tos168/wp-tm-tos168/typescript/popup/Entertainment.vue?vue&type=template"
          $$Component.render = render
          export default $$Component